{
  "id": "planterBox",
  "name": "Rustic Planter Box",
  "builds": "product",
  "category": "rustic",
  "note": "Screws, not nails. Wet soil works a nail loose by August.",
  "skill": "rusticProjects",
  "duration": 25,
  "offeredBy": "drill",
  "fastener": "screws",
  "value": 13,
  "widthIn": 24,
  "heightIn": 24,
  "slots": [
    {
      "id": "slat-0",
      "role": "slat",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "pallet"
      },
      "xIn": 12,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "wall-0",
      "role": "wall",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "pallet"
      },
      "xIn": 12,
      "yIn": 2,
      "angleDeg": 90,
      "zIn": 1,
      "onEdge": true
    },
    {
      "id": "wall-1",
      "role": "wall",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "pallet"
      },
      "xIn": 12,
      "yIn": 22,
      "angleDeg": 90,
      "zIn": 1,
      "onEdge": true
    },
    {
      "id": "wall-2",
      "role": "wall",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "pallet"
      },
      "xIn": 2,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 5,
      "onEdge": true
    },
    {
      "id": "wall-3",
      "role": "wall",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "pallet"
      },
      "xIn": 22,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 5,
      "onEdge": true
    }
  ],
  "fasteners": [
    {
      "xIn": 12,
      "yIn": 2
    },
    {
      "xIn": 12,
      "yIn": 22
    },
    {
      "xIn": 2,
      "yIn": 2
    },
    {
      "xIn": 22,
      "yIn": 2
    },
    {
      "xIn": 2,
      "yIn": 22
    },
    {
      "xIn": 22,
      "yIn": 22
    }
  ]
}
